module.exports = require('./dvr_controls')



/** WEBPACK FOOTER **
 ** ./src/plugins/dvr_controls/index.js
 **/